import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface InitialState {
  timeBegin: number | null,
  timeEnd: number | null,
}

export const initialState: InitialState = {
  timeBegin: null,
  timeEnd: null,
};

export const aggrFiltersSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    selectTime: (state, action: PayloadAction<{
      timeBegin: number,
      timeEnd: number,
    }>) => {
      state.timeBegin = action.payload.timeBegin;
      state.timeEnd = action.payload.timeEnd;
    },
  },
});

export const { selectTime } = aggrFiltersSlice.actions;
export default aggrFiltersSlice.reducer;
